export function pannable(node) {
  let lastX = 0;
  let lastY = 0;

  function dispatch(name, detail) {
    node.dispatchEvent(new CustomEvent(name, { detail }));
  }

  function onMouseDown(event) {
    lastX = event.clientX;
    lastY = event.clientY;
    dispatch('panstart', { x: lastX, y: lastY, target: event.target });

    window.addEventListener('mousemove', onMouseMove);
    window.addEventListener('mouseup', onMouseUp);
  }

  function onMouseMove(event) {
    const dx = event.clientX - lastX;
    const dy = event.clientY - lastY;
    lastX = event.clientX;
    lastY = event.clientY;
    dispatch('panmove', { x: lastX, y: lastY, dx, dy });
  }

  function onMouseUp(event) {
    lastX = event.clientX;
    lastY = event.clientY;
    dispatch('panend', { x: lastX, y: lastY });

    window.removeEventListener('mousemove', onMouseMove);
    window.removeEventListener('mouseup', onMouseUp);
  }

  function onTouchStart(event) {
    if (event.touches.length > 1) return;
    const touch = event.touches[0];
    lastX = touch.clientX;
    lastY = touch.clientY;
    dispatch('panstart', { x: lastX, y: lastY, target: touch.target });

    window.addEventListener('touchmove', onTouchMove, { passive: false });
    window.addEventListener('touchend', onTouchEnd);
  }

  function onTouchMove(event) {
    event.preventDefault();
    if (event.touches.length > 1) return;
    const touch = event.touches[0];

    const dx = touch.clientX - lastX;
    const dy = touch.clientY - lastY;
    lastX = touch.clientX;
    lastY = touch.clientY;

    dispatch('panmove', { x: lastX, y: lastY, dx, dy });
  }

  function onTouchEnd(event) {
    const touch = event.changedTouches[0];
    lastX = touch.clientX;
    lastY = touch.clientY;
    dispatch('panend', { x: lastX, y: lastY });

    window.removeEventListener('touchmove', onTouchMove);
    window.removeEventListener('touchend', onTouchEnd);
  }

  node.addEventListener('mousedown', onMouseDown);
  node.addEventListener('touchstart', onTouchStart);
  return {
    destroy() {
      node.removeEventListener('mousedown', onMouseDown);
      node.removeEventListener('touchstart', onTouchStart);

      window.removeEventListener('mousemove', onMouseMove);
      window.removeEventListener('mouseup', onMouseUp);
      window.removeEventListener('touchmove', onTouchMove);
      window.removeEventListener('touchend', onTouchEnd);
    },
  };
}
